<template>
  <div v-if="selectedModel && groupedOptions">
    <custom-select
      v-model="selectedModel"
      :options="groupedOptions"
      label="translatedName"
      :searchable="searchable"
      :filterable="filterable"
      @input="onChange"
    >
      <template slot-scope="{ option }">
        <span
          v-if="option.isSelectorGroupName"
          class="mb-0 text-muted"
        >
          {{ option.name }}
        </span>
        <span v-else-if="$te(`membersWrapper.tableItem.roles.baseRoles.${option.name}`)">
          {{ $t(`membersWrapper.tableItem.roles.baseRoles.${option.name}`) }}
        </span>
        <span v-else>
          {{ option.name }}
        </span>
      </template>
    </custom-select>
  </div>
</template>

<script>
import CustomSelect from '@/shared-modules/shared-components/shared/custom-select';
import WrapperMessages from '@/shared-modules/shared-components/wrappers/messages/wrapper.messages';
export default {
  components: { CustomSelect },
  name: 'GfEntityMembersRoleSelector',
  props: {
    searchable: {
      type: Boolean,
      default: true
    },
    options: {
      default: () => {
        return ['Нет опций'];
      }
    },
    searchable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      selectedModel: null,
      groupedOptions: [],
      headers: {
        baseProjectRoles: {
          name: this.$t('membersWrapper.tableItem.roles.titles.baseProjectRoles'),
          isSelectorGroupName: true
        },
        globalRoles: {
          name: this.$t('membersWrapper.tableItem.roles.titles.globalRoles'),
          isSelectorGroupName: true
        },
        companyRoles: {
          name: this.$t('membersWrapper.tableItem.roles.titles.companyRoles'),
          isSelectorGroupName: true
        }
      }
    };
  },
  computed: {
    groupedRolesArray() {
      return Object.values(this.options);
    }
  },
  watch: {
    selected: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.name) {
          this.selectedModel = {
            ...newValue,
            translatedName: this.$te(`membersWrapper.tableItem.roles.baseRoles.${newValue.name}`)
              ? this.$t(`membersWrapper.tableItem.roles.baseRoles.${newValue.name}`)
              : newValue.name
          };
        } else {
          this.selectedModel = null;
        }
      }
    }
  },
  methods: {
    makeGroupedOptions() {
      for (let i = 0; i < this.groupedRolesArray.length; i++) {
        if (!this.groupedRolesArray[i] || this.groupedRolesArray[i].length <= 0) {
          continue;
        }

        if (this.headers[Object.keys(this.options)[i]]) {
          this.groupedOptions.push(this.headers[Object.keys(this.options)[i]]);
        }

        for (let j = 0; j < this.groupedRolesArray[i].length; j++) {
          const option = this.groupedRolesArray[i][j];
          this.groupedOptions.push({
            ...option,
            translatedName: this.$te(`membersWrapper.tableItem.roles.baseRoles.${option.name}`)
              ? this.$t(`membersWrapper.tableItem.roles.baseRoles.${option.name}`)
              : option.name
          });
        }
      }
    },
    onChange() {
      this.$emit('role-change', {
        name: this.selectedModel.name,
        role: this.selectedModel.uuid
      });
    }
  },
  mounted() {
    this.makeGroupedOptions();
    this.selectedModel = {
      ...this.selected,
      translatedName: this.$te(`membersWrapper.tableItem.roles.baseRoles.${this.selected.name}`)
        ? this.$t(`membersWrapper.tableItem.roles.baseRoles.${this.selected.name}`)
        : this.selected.name
    };
  },
  i18n: {
    messages: WrapperMessages
  }
};
</script>
